import ReactModal from 'react-modal'
import { X } from 'react-feather'

type VideoModalProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  videoUrl: string | null
  title: string
}

const VideoModal = ({
  isOpen,
  setIsOpen,
  videoUrl,
  title,
}: VideoModalProps) => {
  if (!videoUrl) return null

  // Extract video ID from YouTube URL
  const getYouTubeVideoId = (url: string) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    const match = url.match(regExp)
    return match && match[7].length === 11 ? match[7] : null
  }

  // Check if it's a YouTube URL
  const isYouTube =
    videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')
  const videoId = isYouTube ? getYouTubeVideoId(videoUrl) : null

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      shouldCloseOnEsc={true}
      className="fixed inset-0 flex items-center justify-center p-4 outline-none"
      overlayClassName="fixed inset-0 bg-black bg-opacity-75"
      style={{ overlay: { zIndex: 150 } }}
    >
      <div className="relative w-full max-w-4xl">
        {/* Close button positioned outside modal */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute right-0 z-50 text-white hover:bg-white hover:bg-opacity-10 focus:outline-none p-2 rounded transition-colors"
          style={{ top: '-40px', marginRight: '-10px' }}
        >
          <X size={32} />
        </button>

        <div className="bg-black rounded-lg overflow-hidden">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            {isYouTube && videoId ? (
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <video
                className="absolute top-0 left-0 w-full h-full"
                controls
                autoPlay
                src={videoUrl}
              >
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

export default VideoModal
